import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        user: '=',
        sites: '='
    },
    template: `
        <list-empty list="vm.sites" show-add-message="false"></list-empty>
        <div class="well" ng-if="vm.sites.length">
            <table class="data01">
                <thead>
                <tr>
                    <th class="w1p nosort" type="checkbox"></th>
                    <th>{{ 'manage.Site' | translate }}</th>
                    <th>{{ 'manage.Role' | translate }}</th>
                    <th class="nosort">&nbsp;</th>
                </tr>
                </thead>
                <tbody>
                <tr ng-repeat="site in vm.sites">
                    <td><input type="checkbox" ng-checked="vm.hasSite(site.id)" ng-click="$event.stopPropagation();vm.toggleSite(site.id)"></td>
                    <td><a ui-sref="authorized.manage.permissions.sites.detail({ id: site.id })">{{ site.name }}</a></td>
                    <td>
                        <span ng-repeat="assignedRole in vm.assignedRoles[site.id]">
                            <a
                                ng-if="vm.roles[assignedRole.roleId].isVisible"
                                ui-sref="authorized.manage.permissions.roles.detail.privileges({ id: assignedRole.roleId })"
                                >{{ vm.roles[assignedRole.roleId].name }}
                            </a>
                            <span ng-if="!vm.roles[assignedRole.roleId].isVisible">{{ vm.roles[assignedRole.roleId].name }}</span>
                            <a
                               ng-if="vm.hasMyEmployeesAddPrivilege(assignedRole.privilegesJson)"
                               ui-sref="authorized.user.employee.detail({ id: assignedRole.userId })"
                             >
                                ({{ 'user.Can add employees' | translate }})
                            </a>
                            <a
                               ng-if="vm.hasAllLearnersReportViewPrivilege(assignedRole.privilegesJson)"
                               ui-sref="authorized.user.employee.detail({ id: assignedRole.userId })"
                             >
                                ({{ 'user.Allow to monitor learner progress for all site users' | translate }})
                            </a>
                            <span ng-show="!$last ">, </span>
                        <span>
                    </td>
                    <td class="actions">
                        <a class="btn edit" ng-click="vm.editRoles(vm.user, [site.id], vm.assignedRoles, true)">{{ 'manage.Change role' | translate }}</a>
                        <a class="btn view" ng-click="vm.viewPrivileges(vm.user, site.id)">{{ 'manage.View privileges' | translate }}</a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <ul class="actions01">
            <li class="primary"><a ng-click="vm.editRoles(vm.user, vm.siteIds, [], false)" class="btn main">{{ 'manage.Add roles' | translate }}</a></li>
        </ul>
    `
})
export default class {
    constructor (lodash, TokenService, UserService, UserResource, ROLE_PRIVILEGE_ENUM) {
        this.lodash = lodash;
        this.TokenService = TokenService;
        this.UserService = UserService;
        this.UserResource = UserResource;
        this.ROLE_PRIVILEGE_ENUM = ROLE_PRIVILEGE_ENUM;
    }

    $onInit () {
        this.siteIds = [];
        this.initRoles();
    }

    hasSite (key) {
        return this.lodash.includes(this.siteIds, key);
    }

    toggleSite (key) {
        if (this.hasSite(key)) {
            this.lodash.pull(this.siteIds, key);
        }
        else {
            this.siteIds.push(key);
        }
    }

    initRoles () {
        this.assignedRoles = [];
        this.user.userAssignments.forEach((val) => {
            if (this.assignedRoles[val.siteId] === undefined) {
                this.assignedRoles[val.siteId] = [];
            }
            this.assignedRoles[val.siteId].push(val);
        });

        // index roles by role id
        this.roles = [];
        this.user.roles.forEach((val) => {
            this.roles[val.id] = val;
        });
    }

    viewPrivileges (user, siteId) {
        this.UserService.viewPrivileges(user, siteId);
    }

    editRoles (user, siteIds, userAssignments, removeMissingRoles) {
        this.UserService
            .editRoles(user, siteIds, userAssignments, removeMissingRoles, 'user')
            .then(() => {
                this.UserResource.get({ id: this.user.id, expand: 'sites,userAssignments,roles' })
                    .$promise.then((reloadedUser) => {
                        this.user = reloadedUser;
                        this.initRoles();
                    });
                this.siteIds = [];
            });
    }

    hasMyEmployeesAddPrivilege (privileges) {
        return privileges.includes(this.ROLE_PRIVILEGE_ENUM.KEYS.MY_EMPLOYEE_ADD);
    }

    hasAllLearnersReportViewPrivilege (privileges) {
        return privileges.includes(this.ROLE_PRIVILEGE_ENUM.KEYS.ALL_LEARNERS_REPORT_VIEW);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/permissions/users/detail/sites/index.js